import {orderWarehouseNameSelector} from '../../../data/orders.js'
import {useSelector} from '../../../store.js'

export default function OrderWarehouse({orderNumber}) {
  const warehouseName = useSelector((state) =>
    orderWarehouseNameSelector(state, {orderNumber}),
  )

  return <span>{warehouseName}</span>
}
